import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { FilingConductorDataModel, FilingConductorDataModelCountResponse } from './types';

export interface UseFilingConductorDataModelCountParams {
  corporationId: number | null;
  rootFiCompanyId: number;
  dataModel: FilingConductorDataModel;
  /** Inclusive analysis-window bounds (ISO date). */
  from: string | null;
  to: string | null;
  /** Defer the (proxied RootFi) request until the accordion is expanded. */
  enabled?: boolean;
}

/** Proxies the RootFi record count for one sales data model within the analysis window. */
export function useFilingConductorDataModelCount({ corporationId, rootFiCompanyId, dataModel, from, to, enabled = true }: UseFilingConductorDataModelCountParams) {
  const canFetch = enabled && corporationId !== null && !!from && !!to;
  const query = canFetch
    ? new URLSearchParams({ dataModel, transactionStartDate: from as string, transactionEndDate: to as string }).toString()
    : '';
  const key = canFetch ? `rootfi/companies/${rootFiCompanyId}/transactions/count?${query}` : null;

  const { data, error, isLoading } = useSWR<FilingConductorDataModelCountResponse>(key, SWRFetcher({ method: 'GET' }));

  return {
    count: data?.count ?? null,
    isLoading,
    error,
  };
}
